import type { SongRequest } from '../services/requests';
import type { ProviderRecognition } from '../services/songRecognition';

export const RECOGNITION_WARNING_TOP = 3;
export const REMOVE_FLAG_PROMPT_AFTER = 3;

export type RecognitionWarningLevel = 'serious' | 'mild';
export type NextSongLockState = 'notQueued' | 'queuedUnlocked' | 'locked';

// index is the song's place among the player songs in display order; 0 is next up
export function recognitionWarningLevel(index: number): RecognitionWarningLevel | null {
  if (index < 0 || index >= RECOGNITION_WARNING_TOP) return null;
  return index === 0 ? 'serious' : 'mild';
}

export function nextSongLockState(request: Pick<SongRequest, 'lockedNext'>, queuedInPlayer: boolean): NextSongLockState {
  if (request.lockedNext) return 'locked';
  return queuedInPlayer ? 'queuedUnlocked' : 'notQueued';
}

export function recognitionWarningMessage(level: RecognitionWarningLevel, lockState: NextSongLockState, playerLabel: string): string {
  if (level === 'mild') return `Bridge has missed this song in ${playerLabel} before.`;
  if (lockState === 'locked') return `Bridge may not catch this one. It's locked next, so nothing can jump ahead of it.`;
  if (lockState === 'queuedUnlocked') return `Bridge may not catch this one. Lock it so nothing jumps ahead in ${playerLabel}.`;
  return `Bridge may not catch this one. Keep it next in ${playerLabel} (it locks when you mark it queued).`;
}

export function shouldPromptRemoveFlag(
  request: Pick<SongRequest, 'id' | 'bridgeCleanWhileFlagged'> | null,
  flag: ProviderRecognition | null,
  dismissedRequestIds: ReadonlySet<string>,
): boolean {
  if (!request || !flag?.flagged) return false;
  if (dismissedRequestIds.has(request.id)) return false;
  return (request.bridgeCleanWhileFlagged ?? 0) >= REMOVE_FLAG_PROMPT_AFTER;
}
